import { render } from "./header.vue?vue&type=template&id=e3a6eaa4"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=e3a6eaa4&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__